/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { additionalQuestionDataAttributeSchema } from './AdditionalQuestionDataAttributeSchema'
import { additionalQuestionDataSubtypeSchema } from './AdditionalQuestionDataSubtypeSchema'
import { additionalQuestionDataTypeSchema } from './AdditionalQuestionDataTypeSchema'

export const additionalQuestionDataSchema = z.object({
	id: z.string(),
	formId: z.string(),
	label: z.string(),
	type: additionalQuestionDataTypeSchema,
	subtype: additionalQuestionDataSubtypeSchema.nullable(),
	attribute: additionalQuestionDataAttributeSchema.nullable(),
	validationRules: z.array(z.string()).nullable(),
	options: z.array(
		z.object({
			id: z.string().uuid(),
			label: z.string(),
			position: z.number(),
			consentType: z.string().nullable(),
			escoSkills: z.array(
				z.object({ conceptUri: z.string(), preferredLabel: z.string(), confirmedByUser: z.boolean() }),
			).nullable(),
			escoMappingReason: z.string().nullable(),
		}),
	).nullable(),
	targetScoreRanges: z.array(z.string()).nullable(),
	position: z.number(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
})

export type AdditionalQuestionDataSchema = z.infer<typeof additionalQuestionDataSchema>
